import moment from "moment";
import apiConfig from "../../../config/api.config";
import { extractRoute } from "../../../config/router.config";
import { AthenaProducts } from "../../../config/product.config";

const { NODE_ENV } = apiConfig;

export const createRetryEnachPayload = async (item, method) => {
  const premiumMode = item?.benefitIllustration?.PremiumMode;
  const date = new Date();
  const todayDate = moment(date).format("YYYY/MM/DD");
  const enachDate = premiumMode === "4" ? moment(date).add(2, "months").format("YYYY/MM/DD") : todayDate;
  const sameProposer = item?.benefitIllustration?.SameProposer;
  const enabledProducts = item?.benefitIllustration?.PR_Id === AthenaProducts.AVIVA_POS_SIGNATURE_GUARANTEED_CODE.product_code
  || item?.benefitIllustration?.PR_Id === AthenaProducts.AVIVA_SMART_MONTHLY_INCOME_PLAN_CODE.product_code 
  const enachAmount = enabledProducts ? item?.benefitIllustration?.InstallmentPremium_calc : item?.benefitIllustration?.InstallmentPremium;

  const bankAccountNumber = sameProposer === true ? item?.FinancialDetails?.BankAccountNo : item?.ProposerDetails?.ProposerFinancialDetails?.proposerbankaccountnumber;
  const primaryMobileNumber = item?.leadId?.primaryMobile.toString();
  const primaryEmailId = item?.leadId?.email?.toString();
  const bankAccountType = sameProposer === true ? item?.FinancialDetails?.BankAccountType : item?.ProposerDetails?.ProposerFinancialDetails?.proposerbankaccounttype;
  const bankIFSCCode = sameProposer === true ? item?.FinancialDetails?.IFSCCode : item?.ProposerDetails?.ProposerFinancialDetails?.proposerifscCode;
  const policyId = item?.policyId;
  const customerName = sameProposer === true ? item?.FinancialDetails?.NameAsPerBankAccount : item?.ProposerDetails?.ProposerFinancialDetails?.proposernameasperbankaccount;
  const bankCode = sameProposer === true ? item?.FinancialDetails?.BankName : item?.ProposerDetails?.ProposerFinancialDetails?.proposerbankName;
  const proposalId = item?._id;
  let inputMode = "";

  if (premiumMode == "1") {
    inputMode = "Y";
  } else if (premiumMode == "2") {
    inputMode = "H";
  } else if (premiumMode == "3") {
    inputMode = "Q";
  } else if (premiumMode == "4") {
    inputMode = "M";
  } else if (premiumMode == "5") {
    inputMode = "S";
  }

  const EnachPayload = {
    // AppID: "900014",
    // MerchantKey: "UAT900014",
    BankAc: bankAccountNumber,
    Amt: enachAmount,
    Phone: primaryMobileNumber,
    Email: primaryEmailId,
    CollectionAmt: "",
    MDate: todayDate, //Todays Date
    TDebit: bankAccountType,
    IFSC: bankIFSCCode,
    MICR: "", //optional
    Frequency: "A", // from BI Colection Monthly ,halfyery
    DType: "M", // ok
    Ref1: policyId, // Corporate Refrence number //UPF number pass
    Ref2: "",
    PFrom: enachDate, //  REQUIRED premium date selection and need to integrate form BE
    PTo: "", // OPTIONAL  premium date selection and need to integrate form BE
    UntlCancel: "1",
    Cust1: customerName,
    Cust2: "",
    Cust3: "",
    EMIdate: "",
    BankCode: bankCode,
    FirstCollectionDate: "",
    proposal_id: proposalId,
    subPaymentMode: method,
  };

  return EnachPayload;
};

export const renderMandateStatus = (item) => {
  if (item?.benefitIllustration?.PremiumMode === "5") {
    return "Not applicable";
  } else {
    const subsequentPaymentMode = item?.subsequentPaymentMode;
    let mandateStatus = null;

    if (subsequentPaymentMode === "enach") {
      mandateStatus = renderEnachStatus(item);
    } else if (subsequentPaymentMode === "ccdc" || subsequentPaymentMode === "upi") {
      mandateStatus = item?.mandateStatus === "SUCCESS" ? "Success" : item?.mandateStatus;
    } else if (subsequentPaymentMode === "No selection") {
      mandateStatus = item?.mandateStatus === "SUCCESS" ? "Success" : item?.mandateStatus;
    } else if (subsequentPaymentMode === "NA") {
      const standingInstruction = item?.standingInstruction;
      if (standingInstruction === undefined || standingInstruction === null || standingInstruction === "") {
        mandateStatus = "Not opted for mandate";
      } else if (standingInstruction === true) {
        mandateStatus = item?.mandateStatus === "SUCCESS" ? "Success" : item?.mandateStatus;
      } else {
        mandateStatus = "Not opted for mandate";
      }
    }

    return mandateStatus;
  }
};

export const renderEnachStatus = (item) => {
  if (item?.eNachMandateStatus) {
    const eNachMandateStatusCode = item?.eNachMandateStatus.ErrCode;
    if (eNachMandateStatusCode === "EmRes100") {
      return "Successful";
    } else if (eNachMandateStatusCode === "EmRes004") {
      return "Unsuccessful";
    } else if (eNachMandateStatusCode === "EmRes005") {
      return "Unsuccessful";
    } else {
      return "Mandate Request Submitted";
    }
  } else {
    const enachStatus = item?.eNachStatus;
    if (enachStatus === "Success") {
      return "Mandate Request Submitted";
    } else if (enachStatus === "Failed") {
      return "Failed";
    } else if (enachStatus === "NA") {
      return "Not opted for e-NACH";
    } else {
      return enachStatus;
    }
  }
};

export const createRetryOnlinePayload = (method, item) => {
  const enabledProducts = item?.benefitIllustration?.PR_Id === AthenaProducts.AVIVA_POS_SIGNATURE_GUARANTEED_CODE.product_code
  || item?.benefitIllustration?.PR_Id === AthenaProducts.AVIVA_SMART_MONTHLY_INCOME_PLAN_CODE.product_code 
  const AmountPayment = enabledProducts ? item?.benefitIllustration?.InstallmentPremium_calc : item?.benefitIllustration?.InstallmentPremium;
  const proposalId = item?._id;
  const currentLocationURL = extractRoute(window.location.href);

  const payload = {
    amount: NODE_ENV === "production" ? AmountPayment : NODE_ENV === "preproduction" ? AmountPayment : "1",
    currency: "356",
    subPaymentMode: method,
    standingInstruction: false,
    device: {
      init_channel: "internet",
      ip: "172.27.240.108", //Man
      mac: "D4-54-8B-6C-14-66", //OP
      imei: "990000112233445", //op
      accept_header: "text/html", //op
      fingerprintid: "61b12c18b5d0cf901be34a23ca64bb19", //op
    },
    customer: {
      first_name: "abs",
      last_name: "ssd",
      email: "test@iorta.in",
      email_alt: "abc@iorta.in",
      mobile: "8884143665",
      mobile_alt: "8884143665",
    },
    FE_URL: currentLocationURL,
    ru: "https://merchant.com",
    proposalID: proposalId,
  };

  return payload;
};

export const createOnlineFlowConfig = (result, method) => {
  const selectedPaymentPreference = method == "upi" ? { payment_categories: ["upi","qr"] } : "ccdc" ? { payment_categories: ["card"] } : {};
  const finalObject = {
    merchantId: result.mercid,
    bdOrderId: result.bdorderid,
    authToken: result.links?.[1]?.headers?.authorization,
    childWindow: false,
    returnUrl: result?.ru,
    retryCount: 3,
    prefs: selectedPaymentPreference,
  };

  return finalObject;
};

export const handleMandateValueCode = (value) => {
  switch (value) {
    case "true":
      return true;
    case "false":
      return false;
    case "NA":
      return "NA";
    default:
      return value;
  }
};

export const handleMandateValuePayload = (value) => {
  switch (value) {
    case true:
      return "true";
    case false:
      return "false";
    case "NA":
      return "NA";
    default:
      return value;
  }
};
